var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZelleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1626_5211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86702 13.665H6.28908C6.21793 13.665 6.1497 13.6367 6.09939 13.5864C6.04908 13.5361 6.02081 13.4678 6.02081 13.3967V11.861H3.46756C3.3695 11.8608 3.2755 11.8218 3.20616 11.7525C3.13682 11.6831 3.0978 11.5891 3.09766 11.4911V10.2503C3.09771 10.1673 3.12547 10.0868 3.17653 10.0214L7.69706 4.25509H3.67029C3.57204 4.25509 3.47781 4.21606 3.40833 4.14659C3.33886 4.07711 3.29983 3.98288 3.29983 3.88463V2.50886C3.29983 2.30502 3.4659 2.13895 3.66974 2.13895H6.01915V0.603227C6.01915 0.455486 6.13967 0.334961 6.28741 0.334961H7.86535C8.01309 0.334961 8.13362 0.455486 8.13362 0.603227V2.13895H10.5347C10.7385 2.13895 10.9046 2.30502 10.9046 2.50886V3.69579C10.9044 3.77828 10.8769 3.85838 10.8263 3.92351L6.27742 9.74483H10.5347C10.7385 9.74483 10.9046 9.9109 10.9046 10.1147V11.4905C10.9046 11.5887 10.8656 11.6828 10.7963 11.7523C10.7269 11.8217 10.6328 11.8608 10.5347 11.861H8.13529V13.3967C8.13529 13.4678 8.10702 13.5361 8.05671 13.5864C8.0064 13.6367 7.93817 13.665 7.86702 13.665Z",
    fill: "#6C1CD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_5211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.33,
    height: 13.33,
    fill: "white",
    transform: "translate(0.335938 0.334961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZelleLogo);
export default __webpack_public_path__ + "static/media/zelle_logo.8cd3f3ee7186da9e8e4b196cb32879b3.svg";
export { ForwardRef as ReactComponent };